export const profile = {
  name: "Rodrigue KOUETE",
  title: "DevOps Engineer",
  email: "rodrigue.kouete1@gmail.com",
  summary:
    "DevOps Engineer with 9+ years of experience leading teams and delivering business process automation and cloud platforms, specializing in Camunda BPM, microservices and AWS cloud infrastructure.",
};

export const certifications = [
  { name: "AWS Certified Developer – Associate", issuer: "Amazon Web Services", year: "2023" },
  { name: "HashiCorp Certified: Terraform Associate", issuer: "HashiCorp", year: "2023" },
];

export const skillGroups = [
  {
    title: "Languages & Frameworks",
    skills: ["Java", "Spring / Spring Boot", "JEE / JSF / JPA-Hibernate", "Python", "Node.js / Express", "Angular", "React"],
  },
  {
    title: "BPM & Workflow",
    skills: ["Camunda 7 & 8", "BPMN / DMN modeling", "Workflow automation"],
  },
  {
    title: "Cloud & AWS",
    skills: ["Lambda", "API Gateway", "EKS", "CloudFormation", "SQS / SNS", "S3 / EC2", "IAM", "Route 53 / VPC", "Textract", "KMS"],
  },
  {
    title: "DevOps & Infrastructure",
    skills: ["Docker", "Kubernetes", "Helm", "Terraform", "GitLab CI", "CodePipeline"],
  },
  {
    title: "Messaging & Integration",
    skills: ["Apache Kafka", "RabbitMQ", "REST APIs"],
  },
  {
    title: "Monitoring & Quality",
    skills: ["Prometheus / Grafana", "EFK / ELK", "JUnit / Pytest / Jest", "SonarQube"],
  },
  {
    title: "Soft Skills",
    skills: ["Team leadership", "Mentoring", "Agile / Scrum", "Stakeholder communication"],
  },
  {
    title: "Languages",
    skills: ["French (native)", "English (technical)"],
  },
];

export const experience = [
  {
    company: "BNP Paribas Partners for Innovation (BP²I)",
    role: "Ingénieur DevOps",
    period: "Jul 2024 – Present",
    highlights: [
      "Manage infrastructure as code (Terraform, Ansible) for deployments across IBM Cloud and on-premise environments",
      "Build and maintain CI/CD deployment pipelines",
      "Develop microservices in Python and Java",
      "Deploy and operate (run/MCO) Kafka clusters",
    ],
    tech: ["Python", "Java", "Kafka", "Airflow", "Ansible", "Terraform", "Kubernetes", "IBM Cloud", "ELK", "Dynatrace", "HashiCorp Vault"],
  },
  {
    company: "Canon Business Services",
    role: "Tech Lead / Camunda",
    period: "Jan 2022 – Jun 2024",
    highlights: [
      "Led the re-architecture of a Camunda-based business platform, migrating critical workflows to serverless AWS Lambda functions",
      "Profiled and optimized the BPM engine's CPU/memory performance, resolving bottlenecks and reducing technical debt",
      "Deployed Camunda 8 on AWS EKS and modernized BPMN/DMN workflows, improving process efficiency by 60%",
      "Mentored developers through code reviews, knowledge-sharing sessions, and technical documentation",
    ],
    tech: ["Java", "Python", "Spring", "Camunda 7/8", "AWS Lambda", "EKS", "CloudFormation", "GitLab CI"],
  },
  {
    company: "Profidéo (France)",
    role: "Lead Java/Camunda Developer",
    period: "Jan 2021 – Dec 2021",
    highlights: [
      "Designed and built a BPM module integrated into Profidéo's core platform for workflow management",
      "Defined technical specifications from functional requirements gathered with stakeholders",
      "Trained developers and end users on the Java/Camunda stack",
    ],
    tech: ["Java", "Spring Boot", "REST", "Camunda", "PostgreSQL", "Kafka", "Docker", "Kubernetes", "AWS"],
  },
  {
    company: "Monstock",
    role: "Camunda Developer",
    period: "Feb 2020 – Nov 2020",
    highlights: [
      "Built and deployed a BPM module to automate Monstock's business processes on AWS EKS",
      "Guided the team on Git workflows and CI/CD practices",
      "Coordinated with DevOps teams on deployment and code quality (SonarQube)",
    ],
    tech: ["Java", "Spring Boot", "Camunda", "MySQL", "Kafka", "Docker", "Kubernetes", "AWS"],
  },
  {
    company: "Codezys",
    role: "Java/Node.js/AWS Developer",
    period: "Jan 2018 – Jan 2020",
    highlights: [
      "Led architecture and development of Eida, an AI-powered language-learning mobile app, on a serverless AWS microservices stack",
      "Provisioned infrastructure with Terraform and deployed services to EKS via Helm and GitLab CI/CD",
      "Delivered Studa, a serverless exam-prep web/mobile app (Lambda, API Gateway, MongoDB)",
      "Coached junior developers and authored API design documentation",
    ],
    tech: ["AWS Lambda", "Terraform", "EKS", "Helm", "Java", "Angular", "Node.js", "MongoDB", "Redis"],
  },
  {
    company: "Learndia (Cameroon)",
    role: "Java Fullstack Developer",
    period: "Jan 2016 – Jan 2018",
    highlights: [
      "Built a full web and mobile platform for secondary-school management, connecting students, teachers, parents and administration",
    ],
    tech: ["Java", "Node.js", "Express", "Angular", "MongoDB", "Microservices"],
  },
];
